import * as R from 'ramda';

import { authServer } from '../auth/keycloak';
import providers from './providers';

const dataProvider = {
  getList: getCaller('getList'),
  getOne: getCaller('getOne'),
  getMany: getCaller('getMany'),
  getManyReference: getCaller('getManyReference'),
  create: getCaller('create'),
  update: getCaller('update'),
  updateMany: getCaller('updateMany'),
  delete: getCaller('delete'),
  deleteMany: getCaller('deleteMany'),
  getStudentSessions: getCaller('getStudentSessions'),
};

function getCaller(operation) {
  return async function caller(resource, params) {
    const provider = R.path([resource, operation], providers);
    if (!provider) {
      throw new Error(
        `Provider ${resource} does not support the operation ${operation}`,
      );
    } else {
      const { url, options = {} } = await provider(params);
      options.headers = new Headers(
        R.merge(R.propOr({}, 'headers', options), {
          Accept: 'application/json',
          Authorization: `Bearer ${authServer.token}`,
        }),
      );
      return fetch(url, options)
        .then(async (res) => {
          const json = await res.json().catch(() => ({}));
          if (!res.ok || json?.error) {
            const message =
              json?.error?.message ||
              json?.message ||
              `Request failed with status ${res.status}`;
            const error = new Error(message);
            error.status = res.status;
            error.payload = json;
            throw error;
          }
          return json;
        })
        .then((json) => {
          const shouldNormalizeSingleRecord =
            operation !== 'getList' &&
            operation !== 'getManyReference' &&
            json?.result &&
            !Array.isArray(json.result) &&
            !json.result.id;
          const normalizedResult = shouldNormalizeSingleRecord
            ? {
                ...json.result,
                id: json.result._id || params?.id,
              }
            : json.result;
          switch (operation) {
            case 'getList':
            case 'getManyReference':
              return {
                data: R.contains('/students/search', url)
                  ? R.reverse(json.result)
                  : json.result,
                total: R.pathOr(
                  json.result.length,
                  ['meta', 'pagination', 'total'],
                  json,
                ),
              };
            default:
              return { data: normalizedResult };
          }
        });
    }
  };
}

export default dataProvider;
